module.exports = __webpack_public_path__ + "img/logo.387c1d26.png";